import { render, staticRenderFns } from "./DeductionsPlanDetailsEdit.vue?vue&type=template&id=007ffb92&scoped=true&"
import script from "./DeductionsPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ffb92",
  null
  
)

export default component.exports